"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* global chrome */

const SEND_MESSAGE_TIMEOUT_MS = 5000;
function _withTimeout(promise) {
  let timer;
  return Promise.race([promise, new Promise(resolve => {
    timer = setTimeout(() => resolve(null), SEND_MESSAGE_TIMEOUT_MS);
  })]).finally(() => clearTimeout(timer));
}
class ChromeOSExtensionService {
  constructor(extensionId) {
    this._extensionId = extensionId;
    this._inflight = null;
  }
  _sendMessage() {
    if (this._inflight) return this._inflight;
    this._inflight = _withTimeout(new Promise(resolve => {
      if (typeof chrome === 'undefined' || !chrome.runtime || !chrome.runtime.sendMessage) {
        resolve(null);
        return;
      }
      chrome.runtime.sendMessage(this._extensionId, {
        methodName: 'getDeviceMetrics'
      }, response => {
        if (chrome.runtime.lastError) {
          console.error('ChromeOSExtensionService', chrome.runtime.lastError.message);
          resolve(null);
        } else if (response && response.error) {
          console.error('ChromeOSExtensionService', response.error);
          resolve(null);
        } else {
          resolve(response ?? null);
        }
      });
    })).finally(() => {
      this._inflight = null;
    });
    return this._inflight;
  }
  collectAll() {
    return this._sendMessage();
  }
  async getDeviceName() {
    try {
      if (navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
        const data = await navigator.userAgentData.getHighEntropyValues(['model']);
        if (data && data.model) return data.model;
      }
    } catch (err) {
      console.error('ChromeOSExtensionService.getDeviceName (userAgentData)', err);
    }
    const metrics = await this._sendMessage();
    return metrics ? metrics.device_model : null;
  }
}
var _default = exports.default = ChromeOSExtensionService;